import { useState } from "react"
import { faClone, faRectangleList } from "@fortawesome/pro-solid-svg-icons"
import IconAndTextButton from "../IconAndTextButton"
import BulkCopyJobModal from "./BulkCopyJobModal"
import JobCopiesModal from "./JobCopiesModal"
import { Space } from "antd"

export type Props = {
  jobId: number
}

const CopyJob = ({ jobId }: Props) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [copiesModalVisible, setCopiesModalVisible] = useState(false)

  return <>
    <Space>
      <IconAndTextButton
        size="large"
        onClick={() => setModalVisible(true)}
        icon={faClone}
        text="Copy"
      />
      <IconAndTextButton
        size="large"
        onClick={() => setCopiesModalVisible(true)}
        icon={faRectangleList}
        text="Copy History"
      />
    </Space>
    <BulkCopyJobModal
      visible={modalVisible}
      onClose={() => setModalVisible(false)}
      jobId={jobId}
    />
    <JobCopiesModal
      isOpen={copiesModalVisible}
      onClose={() => setCopiesModalVisible(false)}
      jobId={jobId}
    />
  </>
}
export default CopyJob
